import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if scrolled more than 10px
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full p-6 md:p-8 flex justify-between items-start z-40 pointer-events-none mix-blend-multiply">
      <div
        className={`pointer-events-auto cursor-pointer group transition-all duration-300 ${
          isScrolled ? "blur-sm" : ""
        }`}
        onClick={() => navigate("/")}
      >
        <h1 className="font-display text-xl font-bold tracking-tight group-hover:opacity-50 transition-opacity">
          ODITI Collectors
        </h1>
        <div className="flex items-center gap-2 mt-1">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <p className="text-sm font-mono uppercase tracking-widest">System Online</p>
        </div>
      </div>
      {orderId && (
        <div
          className={`pointer-events-auto transition-all duration-300 ${isScrolled ? "blur-sm" : ""}`}
        >
          <button
            onClick={() => navigate("/")}
            className="font-mono text-sm uppercase border-b border-transparent hover:border-black transition-all"
          >
            [ End Session ]
          </button>
        </div>
      )}
    </header>
  );
}
